module.exports = __webpack_public_path__ + "img/loading.efd0fa38.png";